module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), (!_vm.formSubmitted) ? _c('form', {
    staticClass: "ls-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.apresentation')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('plans.new.apresentation_information')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.suggested),
      expression: "plan.suggested"
    }],
    staticClass: "ls-float-left select-plan",
    attrs: {
      "name": "plan.suggested",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan.suggested) ? _vm._i(_vm.plan.suggested, null) > -1 : (_vm.plan.suggested)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.plan.suggested,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.plan.suggested = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.plan.suggested = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plan.suggested = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "txt-check"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.recomended_plan')))]), _vm._v(" "), _c('popover', {
    attrs: {
      "position": 'right'
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.popover.suggested')))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('plans.attributes.name'))
    }
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.name),
      expression: "plan.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "plan.name",
      "type": "text",
      "maxlength": "50",
      "placeholder": _vm.$t('plans.new.placeholder.start'),
      "name": _vm.$t('plans.attributes.name')
    },
    domProps: {
      "value": (_vm.plan.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('plans.attributes.name'))),
      expression: "errors.has($t('plans.attributes.name'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('plans.attributes.name'))))]), _vm._v(" "), _c('char-counter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has(_vm.$t('plans.attributes.name'))),
      expression: "!errors.has($t('plans.attributes.name'))"
    }],
    attrs: {
      "max": 50
    },
    model: {
      value: (_vm.plan.name),
      callback: function($$v) {
        _vm.plan.name = $$v
      },
      expression: "plan.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('plans.attributes.description'))
    }
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.description')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.description),
      expression: "plan.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "plan.description",
      "rows": "6",
      "maxlength": "256",
      "name": _vm.$t('plans.attributes.description')
    },
    domProps: {
      "value": (_vm.plan.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('plans.attributes.description'))),
      expression: "errors.has($t('plans.attributes.description'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('plans.attributes.description'))))]), _vm._v(" "), _c('char-counter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has(_vm.$t('plans.attributes.description'))),
      expression: "!errors.has($t('plans.attributes.description'))"
    }],
    attrs: {
      "max": 256
    },
    model: {
      value: (_vm.plan.description),
      callback: function($$v) {
        _vm.plan.description = $$v
      },
      expression: "plan.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('plans.attributes.code'))
    }
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.code')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.code),
      expression: "plan.code"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "plan.code",
      "type": "text",
      "maxlength": "100",
      "name": _vm.$t('plans.attributes.code')
    },
    domProps: {
      "value": (_vm.plan.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('plans.attributes.code'))),
      expression: "errors.has($t('plans.attributes.code'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('plans.attributes.code'))))]), _vm._v(" "), _c('char-counter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has(_vm.$t('plans.attributes.code'))),
      expression: "!errors.has($t('plans.attributes.code'))"
    }],
    attrs: {
      "max": 100
    },
    model: {
      value: (_vm.plan.code),
      callback: function($$v) {
        _vm.plan.code = $$v
      },
      expression: "plan.code"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix ls-md-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.value_and_periodicity')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('plans.new.deadline_message')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('plans.attributes.periodicity'))
    }
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('plans.attributes.periodicity')) + "\n              "), _c('popover', {
    attrs: {
      "position": 'right'
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.popover.periodicity')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 ls-no-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.periodicity),
      expression: "plan.periodicity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:0'),
      expression: "'required|decimal:0'"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "name": "plan.periodicity",
      "name": _vm.$t('plans.attributes.periodicity')
    },
    domProps: {
      "value": (_vm.plan.periodicity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.periodicity = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('plans.attributes.periodicity'))),
      expression: "errors.has($t('plans.attributes.periodicity'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('plans.attributes.periodicity'))))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-12"
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.period_plan')) + "\n              "), _c('popover', {
    attrs: {
      "position": 'right'
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.popover.duration')))])])], 1), _vm._v(" "), _c('p', [_vm._v("Ilimitado")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-6",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('plans.attributes.price'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('plans.new.value')))]), _vm._v(" "), _c('money-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": _vm.plan.price,
      "name": _vm.$t('plans.attributes.price')
    },
    on: {
      "updateValue": function (value) {
        _vm.plan.price = value
      }
    },
    model: {
      value: (_vm.plan.price),
      callback: function($$v) {
        _vm.plan.price = $$v
      },
      expression: "plan.price"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('plans.attributes.price'))),
      expression: "errors.has($t('plans.attributes.price'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('plans.attributes.price'))))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('div', {
    staticClass: "ls-float-right"
  }, [_c('router-link', {
    staticClass: "ls-btn",
    attrs: {
      "to": {
        name: 'plans'
      },
      "title": _vm.$t('application.button.cancel')
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.include_plan')))])], 1)])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4714980e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/plans/New.vue
// module id = 768
// module chunks = 1